var exports = {
  "a": "Box__WDNbGt",
  "W": "CopyToClipboardIconButton__m6mWyO",
};

module.exports = exports;
